import React from 'react';
import FicoContent from '../components/FicoContent/FicoContent';
import CtaSection from '../components/CtaSection/CtaSection';

const SapFicoPage = () => {
  return (
    <>
      <FicoContent />
      <CtaSection />
    </>
  );
};

export default SapFicoPage;
